import api from '../api/flexapi';

export const BENEFIT_STATEMENT_LOAD_BEGIN = 'BENEFIT_STATEMENT_LOAD_BEGIN';
export const BENEFIT_STATEMENT_LOAD_SUCCESS = 'BENEFIT_STATEMENT_LOAD_SUCCESS';
export const BENEFIT_STATEMENT_LOAD_FAILED = 'BENEFIT_STATEMENT_LOAD_FAILED';

export const BENEFIT_SETTINGS_LOAD_BEGIN = 'BENEFIT_SETTINGS_LOAD_BEGIN';
export const BENEFIT_SETTINGS_LOAD_SUCCESS = 'BENEFIT_SETTINGS_LOAD_SUCCESS';
export const BENEFIT_SETTINGS_LOAD_FAILED = 'BENEFIT_SETTINGS_LOAD_FAILED';

export const loadBenefitStatement = (data = {}) => (dispatch) => {
  dispatch({ type: BENEFIT_STATEMENT_LOAD_BEGIN });
  
  return api.getBenefitStatement(data)
    .then((response) => {
      dispatch({ type: BENEFIT_STATEMENT_LOAD_SUCCESS, payload: response.body });
    })
    .catch((err) => {
      dispatch({
        type: BENEFIT_STATEMENT_LOAD_FAILED,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const loadBenefitSettings = (data = {}) => (dispatch) => {
  dispatch({ type: BENEFIT_SETTINGS_LOAD_BEGIN });
  
  return api.getBenefitSettings(data)
    .then((response) => {
      dispatch({ type: BENEFIT_SETTINGS_LOAD_SUCCESS, payload: response.body });
    })
    .catch((err) => {
      dispatch({
        type: BENEFIT_SETTINGS_LOAD_FAILED,
        payload: err.response ? err.response.body : err,
      });
    });
};


// WEBPACK FOOTER //
// ./actions/benefitStatementActions.jsx